export const GET_CALL_CHECK_LOADS_LOADING = 'GET_CALL_CHECK_LOADS_LOADING';
export const GET_CALL_CHECK_LOADS = 'GET_CALL_CHECK_LOADS';
export const FILTER_CALL_CHECK_LOADS = 'FILTER_CALL_CHECK_LOADS';
export const CALL_CHECK_LOADS_ERROR = 'CALL_CHECK_LOADS_ERROR';
export const RELOAD_ON_ERROR_CALL_CHECK_LOADS = 'RELOAD_ON_ERROR_CALL_CHECK_LOADS';
export const RESET_ERROR = 'RESET_ERROR';
export const SET_DISPLAY_STATE_CALL_CHECK_LOADS = 'SET_DISPLAY_STATE_CALL_CHECK_LOADS';
export const SET_HEADER_WIDTH_CALL_CHECK_LOADS = 'SET_HEADER_WIDTH_CALL_CHECK_LOADS';
export const SET_HEADER_WIDTH_CALL_CHECK_LOADS_DETAILS = 'SET_HEADER_WIDTH_CALL_CHECK_LOADS_DETAILS';
export const SET_CALL_CHECK_LOADS_DATA = 'SET_CALL_CHECK_LOADS_DATA';
export const CALL_CHECK_LOADS_PAGINATION = 'CALL_CHECK_LOADS_PAGINATION';
export const SET_CALL_CHECK_LOADS_LOADS_STATUS_DATA = 'SET_CALL_CHECK_LOADS_LOADS_STATUS_DATA';
export const SET_CALL_CHECK_LOADS_STOPS_STATUS_DATA = 'SET_CALL_CHECK_LOADS_STOPS_STATUS_DATA';
export const SET_CALL_CHECK_LOADS_STOPS_DETAILS_STATUS_DATA = 'SET_CALL_CHECK_LOADS_STOPS_DETAILS_STATUS_DATA';
export const GET_CALL_CHECK_LOADS_LOAD_NOTES = 'GET_CALL_CHECK_LOADS_LOAD_NOTES';
export const GET_CALL_CHECK_LOADS_LOAD_NOTES_LOADING = 'GET_CALL_CHECK_LOADS_LOAD_NOTES_LOADING';
export const GET_CALL_CHECK_LOADS_LOAD_NOTES_ERROR = 'GET_CALL_CHECK_LOADS_LOAD_NOTES_ERROR';
export const GET_CALL_CHECK_LOADS_STOP_NOTES = 'GET_CALL_CHECK_LOADS_STOP_NOTES';
export const GET_CALL_CHECK_LOADS_STOP_NOTES_LOADING = 'GET_CALL_CHECK_LOADS_STOP_NOTES_LOADING';
export const GET_CALL_CHECK_LOADS_STOP_NOTES_ERROR = 'GET_CALL_CHECK_LOADS_STOP_NOTES_ERROR';
export const SET_CALL_CHECK_LOADS_LOAD_NOTE = 'SET_CALL_CHECK_LOADS_LOAD_NOTE';
export const SET_CALL_CHECK_LOADS_LOAD_NOTE_LOADING = 'SET_CALL_CHECK_LOADS_LOAD_NOTE_LOADING';
export const SET_CALL_CHECK_LOADS_LOAD_NOTE_ERROR = 'SET_CALL_CHECK_LOADS_LOAD_NOTE_ERROR';
export const SET_CALL_CHECK_LOADS_STOP_NOTE = 'SET_CALL_CHECK_LOADS_STOP_NOTE';
export const SET_CALL_CHECK_LOADS_STOP_NOTE_LOADING = 'SET_CALL_CHECK_LOADS_STOP_NOTE_LOADING';
export const SET_CALL_CHECK_LOADS_STOP_NOTE_ERROR = 'SET_CALL_CHECK_LOADS_STOP_NOTE_ERROR';
export const SET_CALL_CHECK_LOADS_CURRENT_USER = 'SET_CALL_CHECK_LOADS_CURRENT_USER';
export const SET_CALL_CHECK_LOADS_CURRENT_USER_LOADING = 'SET_CALL_CHECK_LOADS_CURRENT_USER_LOADING';
export const SET_CALL_CHECK_LOADS_STOPS_DATE = 'SET_CALL_CHECK_LOADS_STOPS_DATE';
export const SET_CALL_CHECK_LOADS_STOPS_DATE_DETAILS = 'SET_CALL_CHECK_LOADS_STOPS_DATE_DETAILS';
export const SET_CALL_CHECK_ALL_NOTES_EMPTY = 'SET_CALL_CHECK_ALL_NOTES_EMPTY';
export const GET_CALL_CHECK_LOAD_DETAILS = 'GET_CALL_CHECK_LOAD_DETAILS';
export const GET_CALL_CHECK_LOAD_DETAILS_ERROR = 'GET_CALL_CHECK_LOAD_DETAILS_ERROR';
export const GET_CALL_CHECK_LOAD_DETAILS_LOADING = 'GET_CALL_CHECK_LOAD_DETAILS_LOADING';
export const SET_CALL_CHECK_LOADS_LOADS_DETAILS = 'SET_CALL_CHECK_LOADS_LOADS_DETAILS';
export const SET_CALL_CHECK_LOADS_ORDER_DELIVER_DATE_DETAILS = 'SET_CALL_CHECK_LOADS_ORDER_DELIVER_DATE_DETAILS';
export const GET_EFS_LIST = 'GET_EFS_LIST';
export const EFS_LIST_ERROR = 'EFS_LIST_ERROR';
export const EFS_LIST_LOADING = 'EFS_LIST_LOADING';
export const EMPTY_EFS_ERROR = 'EMPTY_EFS_ERROR';
export const EMPTY_EFS_LOADING = 'EMPTY_EFS_LOADING';
export const GET_EFS_LOADING = 'GET_EFS_LOADING';
export const GET_EFS_ERROR = 'GET_EFS_ERROR';
export const GET_EFS = 'GET_EFS';
export const GET_EMPTY_EFS = 'GET_EMPTY_EFS';
export const SET_EFS_LOADING = 'SET_EFS_LOADING';
export const SET_EFS_ERROR = 'SET_EFS_ERROR';
export const SET_EFS = 'SET_EFS';
export const UPDATE_EFS_LOADING = 'UPDATE_EFS_LOADING';
export const UPDATE_EFS_ERROR = 'UPDATE_EFS_ERROR';
export const UPDATE_EFS = 'UPDATE_EFS';
export const GET_CALL_CHECK_LOADS_ORDER_NOTES_ERROR = 'GET_CALL_CHECK_LOADS_ORDER_NOTES_ERROR';
export const GET_CALL_CHECK_LOADS_ORDER_NOTES = 'GET_CALL_CHECK_LOADS_ORDER_NOTES';
export const GET_CALL_CHECK_LOADS_ORDER_NOTES_LOADING = 'GET_CALL_CHECK_LOADS_ORDER_NOTES_LOADING';
export const SET_CALL_CHECK_LOADS_ORDER_NOTE_LOADING = 'SET_CALL_CHECK_LOADS_ORDER_NOTE_LOADING';
export const SET_CALL_CHECK_LOADS_ORDER_NOTE = 'SET_CALL_CHECK_LOADS_ORDER_NOTE';
export const REACT_ITEM = 'REACT_ITEM';

export const getActionType = (resource, key) => {
    return CALL_CHECK_LOADS_BUILD[key];
};

export const CALL_CHECK_LOADS_BUILD = {
    GET_CALL_CHECK_LOADS: 'GET_CALL_CHECK_LOADS',
    GET_CALL_CHECK_LOADS_LOADING: 'GET_CALL_CHECK_LOADS_LOADING',
    FILTER_CALL_CHECK_LOADS: 'FILTER_CALL_CHECK_LOADS',
    CALL_CHECK_LOADS_ERROR: 'CALL_CHECK_LOADS_ERROR',
    RELOAD_ON_ERROR_CALL_CHECK_LOADS: 'RELOAD_ON_ERROR_CALL_CHECK_LOADS',
    SET_HEADER_WIDTH_CALL_CHECK_LOADS: 'SET_HEADER_WIDTH_CALL_CHECK_LOADS',
    SET_HEADER_WIDTH_CALL_CHECK_LOADS_DETAILS: 'SET_HEADER_WIDTH_CALL_CHECK_LOADS_DETAILS',
    SET_DISPLAY_STATE_CALL_CHECK_LOADS: 'SET_DISPLAY_STATE_CALL_CHECK_LOADS',
    RESET_ERROR: 'RESET_ERROR',
    CALL_CHECK_LOADS_PAGINATION: 'CALL_CHECK_LOADS_PAGINATION',
    SET_CALL_CHECK_LOADS_LOADS_STATUS_DATA: 'SET_CALL_CHECK_LOADS_LOADS_STATUS_DATA',
    SET_CALL_CHECK_LOADS_STOPS_STATUS_DATA: 'SET_CALL_CHECK_LOADS_STOPS_STATUS_DATA',
    SET_CALL_CHECK_LOADS_STOPS_DETAILS_STATUS_DATA: 'SET_CALL_CHECK_LOADS_STOPS_DETAILS_STATUS_DATA',
    GET_CALL_CHECK_LOADS_LOAD_NOTES: 'GET_CALL_CHECK_LOADS_LOAD_NOTES',
    GET_CALL_CHECK_LOADS_LOAD_NOTES_LOADING: 'GET_CALL_CHECK_LOADS_LOAD_NOTES_LOADING',
    GET_CALL_CHECK_LOADS_LOAD_NOTES_ERROR: 'GET_CALL_CHECK_LOADS_LOAD_NOTES_ERROR',
    GET_CALL_CHECK_LOADS_STOP_NOTES: 'GET_CALL_CHECK_LOADS_STOP_NOTES',
    GET_CALL_CHECK_LOADS_STOP_NOTES_LOADING: 'GET_CALL_CHECK_LOADS_STOP_NOTES_LOADING',
    GET_CALL_CHECK_LOADS_STOP_NOTES_ERROR: 'GET_CALL_CHECK_LOADS_STOP_NOTES_ERROR',
    SET_CALL_CHECK_LOADS_LOAD_NOTE: 'SET_CALL_CHECK_LOADS_LOAD_NOTE',
    SET_CALL_CHECK_LOADS_LOAD_NOTE_LOADING: 'SET_CALL_CHECK_LOADS_LOAD_NOTE_LOADING',
    SET_CALL_CHECK_LOADS_LOAD_NOTE_ERROR: 'SET_CALL_CHECK_LOADS_LOAD_NOTE_ERROR',
    SET_CALL_CHECK_LOADS_STOP_NOTE: 'SET_CALL_CHECK_LOADS_STOP_NOTE',
    SET_CALL_CHECK_LOADS_STOP_NOTE_LOADING: 'SET_CALL_CHECK_LOADS_STOP_NOTE_LOADING',
    SET_CALL_CHECK_LOADS_STOP_NOTE_ERROR: 'SET_CALL_CHECK_LOADS_STOP_NOTE_ERROR',
    SET_CALL_CHECK_LOADS_CURRENT_USER: 'SET_CALL_CHECK_LOADS_CURRENT_USER',
    SET_CALL_CHECK_LOADS_CURRENT_USER_LOADING: 'SET_CALL_CHECK_LOADS_CURRENT_USER_LOADING',
    SET_CALL_CHECK_LOADS_STOPS_DATE: 'SET_CALL_CHECK_LOADS_STOPS_DATE',
    SET_CALL_CHECK_LOADS_STOPS_DATE_DETAILS: 'SET_CALL_CHECK_LOADS_STOPS_DATE_DETAILS',
    SET_CALL_CHECK_ALL_NOTES_EMPTY: 'SET_CALL_CHECK_ALL_NOTES_EMPTY',
    GET_CALL_CHECK_LOAD_DETAILS: 'GET_CALL_CHECK_LOAD_DETAILS',
    GET_CALL_CHECK_LOAD_DETAILS_ERROR: 'GET_CALL_CHECK_LOAD_DETAILS_ERROR',
    GET_CALL_CHECK_LOAD_DETAILS_LOADING: 'GET_CALL_CHECK_LOAD_DETAILS_LOADING',
    SET_CALL_CHECK_LOADS_LOADS_DETAILS: 'SET_CALL_CHECK_LOADS_LOADS_DETAILS',
    SET_CALL_CHECK_LOADS_ORDER_DELIVER_DATE_DETAILS: 'SET_CALL_CHECK_LOADS_ORDER_DELIVER_DATE_DETAILS',
    GET_EFS_LIST: 'GET_EFS_LIST',
    EFS_LIST_ERROR: 'EFS_LIST_ERROR',
    EFS_LIST_LOADING: 'EFS_LIST_LOADING',
    GET_EMPTY_EFS: 'GET_EMPTY_EFS',
    EMPTY_EFS_ERROR: 'EMPTY_EFS_ERROR',
    EMPTY_EFS_LOADING: 'EMPTY_EFS_LOADING',
    GET_EFS_LOADING: 'GET_EFS_LOADING',
    GET_EFS: 'GET_EFS',
    GET_EFS_ERROR: 'GET_EFS_ERROR',
    SET_EFS_LOADING: 'SET_EFS_LOADING',
    SET_EFS_ERROR: 'SET_EFS_ERROR',
    SET_EFS: 'SET_EFS',
    UPDATE_EFS_LOADING: 'UPDATE_EFS_LOADING',
    UPDATE_EFS_ERROR: 'UPDATE_EFS_ERROR',
    UPDATE_EFS: 'UPDATE_EFS',
    GET_CALL_CHECK_LOADS_ORDER_NOTES_ERROR: 'GET_CALL_CHECK_LOADS_ORDER_NOTES_ERROR',
    GET_CALL_CHECK_LOADS_ORDER_NOTES: 'GET_CALL_CHECK_LOADS_ORDER_NOTES',
    GET_CALL_CHECK_LOADS_ORDER_NOTES_LOADING: 'GET_CALL_CHECK_LOADS_ORDER_NOTES_LOADING',
    SET_CALL_CHECK_LOADS_ORDER_NOTE_LOADING: 'SET_CALL_CHECK_LOADS_ORDER_NOTE_LOADING',
    SET_CALL_CHECK_LOADS_ORDER_NOTE: 'SET_CALL_CHECK_LOADS_ORDER_NOTE',
    REACT_ITEM: 'REACT_ITEM',
};
